/* Toprank "stamp & fly" add-to-cart animation (design card: Cart Drawer.html).
   Called from product-cart.js right before the cart drawer opens:
   window.tlFlyToCart(sourceButton, openDrawerCallback)
   Flies a clone of the product image to the header cart icon, bumps the icon,
   fires the leather-stamp ring, then runs the callback (opens the drawer).
   Falls back to calling the callback immediately when there's nothing to animate. */
(function () {
  function cartTarget() {
    var candidates = document.querySelectorAll('.header-icon-cart');
    for (var i = 0; i < candidates.length; i++) {
      var r = candidates[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0 && r.top >= 0 && r.top < window.innerHeight) return candidates[i];
    }
    return null;
  }

  function sourceImage(btn) {
    var img = null;
    if (btn) {
      var scope = btn.closest('section') || document;
      img = scope.querySelector('[id^="product-media-"] img') || scope.querySelector('.card-media img');
    }
    if (!img) img = document.querySelector('[id^="product-media-"] img');
    if (img) {
      var r = img.getBoundingClientRect();
      if (r.width < 10 || r.height < 10 || r.bottom < 0 || r.top > window.innerHeight) return null;
    }
    return img;
  }

  window.tlFlyToCart = function (btn, done) {
    var finish = typeof done === 'function' ? done : function () {};
    var finished = false;
    var safeFinish = function () { if (!finished) { finished = true; finish(); } };
    try {
      var target = cartTarget();
      var img = sourceImage(btn);
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!target || !img || reduced || !('animate' in Element.prototype)) { safeFinish(); return; }

      var src = img.getBoundingClientRect();
      var dst = target.getBoundingClientRect();
      var size = Math.min(120, Math.round(src.width));
      var clone = img.cloneNode();
      clone.removeAttribute('id');
      clone.removeAttribute('srcset');
      clone.removeAttribute('sizes');
      clone.className = 'tl-fly-clone';
      clone.style.width = size + 'px';
      clone.style.height = size + 'px';
      clone.style.left = (src.left + src.width / 2 - size / 2) + 'px';
      clone.style.top = (src.top + src.height / 2 - size / 2) + 'px';
      document.body.appendChild(clone);

      var dx = (dst.left + dst.width / 2) - (src.left + src.width / 2);
      var dy = (dst.top + dst.height / 2) - (src.top + src.height / 2);

      var landed = false;
      var land = function () {
        if (landed) return;
        landed = true;
        clone.remove();
        /* icon bump */
        target.classList.remove('tl-cart-bump');
        void target.offsetWidth;
        target.classList.add('tl-cart-bump');
        /* leather-stamp confirm ring over the cart icon */
        var st = document.getElementById('tl-stamp-ring');
        if (!st) {
          st = document.createElement('div');
          st.id = 'tl-stamp-ring';
          st.className = 'tl-stamp-ring';
          st.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.4" fill="none"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          document.body.appendChild(st);
        }
        st.style.left = (dst.left + dst.width / 2 - 27) + 'px';
        st.style.top = (dst.top + dst.height / 2 - 27) + 'px';
        st.classList.remove('go');
        void st.offsetWidth;
        st.classList.add('go');
        /* let the stamp read for a beat before the drawer slides over it */
        setTimeout(safeFinish, 260);
      };

      var anim = clone.animate([
        { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + (dx * 0.55) + 'px,' + (dy * 0.5 - 90) + 'px) scale(.5) rotate(-12deg)', opacity: 1, offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(-20deg)', opacity: 0.5 }
      ], { duration: 640, easing: 'cubic-bezier(.5,.05,.35,1)' });
      anim.onfinish = land;
      /* safety net: never leave the drawer unopened */
      setTimeout(function () {
        if (!landed) { try { anim.cancel(); } catch (e) {} land(); }
      }, 1200);
    } catch (e) {
      safeFinish();
    }
  };
})();
